// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vuex from 'vuex';
import Vant from 'vant';
// import 'vant/lib/index.css';

Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(Vuex)

Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    tabsIndex: 4, 
    userInfo: false,
    piaochuang: false,
    roles: '',
    home: false,
    courseList: false,
    examListX: false,
  },
  mutations: {
    tabsIndex(state , n ) {
      state.tabsIndex = n;
    },
    piaochuang(state , n ) {
      state.piaochuang = n;
    },
    userInfo(state , n ) {
      state.userInfo = n;
    },
    roles(state , n ) {
      state.roles = n;
    },
    home(state , n ) {
      state.home = n;
    },
    courseList(state , n ) {
      state.courseList = n;
    },
    examListX(state , n ) {
      state.examListX = n;
    },
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store: store,
  router,
  components: { App },
  template: '<App/>'
})

export default store



// WEBPACK FOOTER //
// ./src/pages/index/index.js